import { ASSESSMENT_COMMENTS_LABELS } from './labels'
import type { CommentFilter } from './types'

export const FILTER_OPTIONS = [
  ['all', ASSESSMENT_COMMENTS_LABELS.allComments],
  ['mine', ASSESSMENT_COMMENTS_LABELS.onlyYourThreads],
] as const satisfies readonly (readonly [CommentFilter, string])[]

export const PLACEHOLDER_COUNT = 4

export const SEARCH_TRACKING_DELAY_MS = 600
